import React from "react";
import FeatureProjects from "./FeatureProjects";
import ProjectArchive from "./ProjectArchive";
import CodeLab from "./CodeLab";

const WorkContainer = () => {
  return (
    <>
      <div className="spacer" data-height="100" />
      <section id="works">
        <div className="container">
          <div className="row">
            <div className="col-md-1" />
            <div className="col-md-10 animate__animated animate__fadeInDown">
              <h1 className="title">
                .works(<span>'selected'</span>)
              </h1>
              <div className="spacer" data-height="10"></div>
              <p>{"// Some special projects I am currently working on."}</p>
            </div>
          </div>
          <div className="spacer" data-height="50" />
          <FeatureProjects />
          <ProjectArchive />
          <CodeLab />
        </div>
      </section>
      <div className="spacer" data-height="100" />
    </>
  );
};

export default WorkContainer;
